// ListViewCompact.jsx

import React from 'react';

// Components
import ListView from './ListView';

/**
 * ListViewCompact
 *
 * Compact list renderer for constrained surfaces (e.g. dashboard cards).
 * Reuses ListView and caps the number of nodes for readability.
 *
 * @returns {ReactNode} The rendered component.
 */
const ListViewCompact = React.memo(({
  enforceExplicitProperties = false,
  view,
  typeDef,
  nodes = [],
  language = 'en',
  onItemClick = null,
}) => {

  // ----- RENDER ----- //

  return (
  <ListView
    enforceExplicitProperties={enforceExplicitProperties}
    view={view}
    typeDef={typeDef}
    nodes={nodes}
    language={language}
    onItemClick={onItemClick}
  />
);
});

// Dev Tools
ListViewCompact.displayName = 'ListViewCompact';

export default ListViewCompact;
